import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Icon } from '@iconify/react/dist/iconify.js';

const DeleteConfirmationModal = ({
  show,
  onHide,
  onConfirm,
  isDeleting = false,
  itemName,
  itemType = 'item',
  confirmButtonVariant = 'danger-focus bg-hover-danger-400 text-danger-600 bg-danger-focus',
  cancelButtonVariant = 'outline-secondary',
  size = 'md',
  className = ''
}) => {
  return (
    <Modal 
      show={show} 
      onHide={onHide}
      centered
      size={size}
      className={`delete-confirmation-modal ${className}`}
      backdrop="static"
    >
      <Modal.Header closeButton closeVariant="gray" className="border-0 pb-0" />
      <Modal.Body className="pt-0 px-3 pb-3 text-center">
        <div className="mb-3">
          <div className="d-flex justify-content-center mb-3">
            <div className="bg-danger-100 p-3 rounded-circle d-inline-flex">
              <Icon icon="fluent:warning-24-filled" className="text-danger" width={32} height={32} />
            </div>
          </div>
          <h6 className="mb-3">Delete {itemType}?</h6>
          <p className="text-muted mb-0">
            Are you sure you want to delete <strong>{itemName}</strong>? This action cannot be undone.
          </p>
        </div>
        <div className="d-flex justify-content-center gap-3 mt-4">
          <Button 
            variant={cancelButtonVariant}
            onClick={onHide}
            disabled={isDeleting}
            className="px-5"
          >
            Cancel
          </Button>
          <Button 
            variant={confirmButtonVariant}
            onClick={onConfirm}
            disabled={isDeleting}
            className="px-5 d-flex align-items-center gap-2"
          >
            {isDeleting ? (
              <>
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Deleting...
              </>
            ) : (
              <>
                <Icon icon="fluent:delete-24-regular" className="me-1" />
                Delete
              </>
            )}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteConfirmationModal;
